export const PROFILE_UPDATE_SUCCESS =
  "프로필이 성공적으로 변경됐습니다. ＼('ω' )／";
export const REGISTER_SUCCESS =
  '회원가입이 성공적으로 완료되었습니다. :.ﾟ٩(๑˘ω˘๑)۶:.｡';
export const LOGIN_SUCCESS = '로그인 되었습니다 ٩( ᐖ )و ';
export const LOGOUT_SUCCESS = "로그아웃 되었습니다 ( *'ω'*)";
